import { emailColorMap, TenantInfo } from './common';
import { tenant as eurbridge } from './eurbridge';
import { tenant as keet } from './keet';
import { tenant as lmj } from './lmj';
import { tenant as pace } from './pace';
import { tenant as pelicargo } from './pelicargo';
import { tenant as worldnet } from './worldnet';

export const tenants = { eurbridge, lmj, pelicargo, pace, keet, worldnet } as const satisfies {
  [Key in string]: TenantInfo<Key>;
};

export const compiledRegex = Object.entries(emailColorMap).map(([name, values]) => {
  const regexp = values.map((r: string) => new RegExp(r, 'gi'));
  return (tenant: keyof typeof tenants, string: string) =>
    regexp.reduce((str, re) => {
      return str.replace(re, tenants[tenant].emailTheme[name]);
    }, string);
});
